export type RoleId =
  | "admin"
  | "superadmin"
  | "supervisor"
  | "warehouse"
  | "operator"
  | "maintenance"
  | "quality"
  | "viewer"
  | string;

const ROLE_MAP: Record<string, RoleId> = {
  // Spanish -> internal ids
  "almacen": "warehouse",
  "almacén": "warehouse",
  "almacenista": "warehouse",
  "operario": "operator",
  "mantenimiento": "maintenance",
  "visitante-invitado": "viewer",
  "visitante_invitado": "viewer",
  "visitante": "viewer",
  "invitado": "viewer",
  "calidad": "quality",
  "superadmin": "superadmin",
  "superadministrador": "superadmin",
  "super-administrador": "superadmin",
};

export const normalizeRole = (role?: string | null): RoleId | null => {
  if (!role) return null;
  const key = role.trim().toLowerCase();
  return ROLE_MAP[key] || key;
};

export const canViewMoney = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === "admin" || r === "superadmin" || r === "supervisor" || r === "warehouse" || r === "inspector";
};

export const canManageInventory = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === "admin" || r === "superadmin" || r === "supervisor" || r === "warehouse";
};

export const canManageRawMaterials = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === "admin" || r === "superadmin" || r === "supervisor" || r === "warehouse";
};

export const canManagePlotterCuts = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === "admin" || r === "superadmin" || r === "supervisor" || r === "warehouse";
};

// Alert visibility by role
export const canViewStockAlerts = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'supervisor' || r === 'warehouse';
};

export const canViewMaintenanceAlerts = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'supervisor' || r === 'maintenance';
};

export const canViewPurchaseAlerts = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'supervisor' || r === 'warehouse';
};

export const canViewAllDashboardAlerts = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r !== 'operator' && r !== 'viewer';
};

// Traceability access
export const canViewTraceabilityHistory = (role?: string | null): boolean => {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin' || r === 'supervisor';
};
